module.exports = __webpack_public_path__ + "static/media/wedding04.189d7528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding04.jpg
// module id = 424
// module chunks = 0